/**
 * Mot de passe — règles partagées par la connexion, l'inscription,
 * /reset-password et /new-user-password.
 * La longueur suit le backend (Devise : config.password_length = 6..128).
 */

export const PASSWORD_MIN = 6;

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Adresse e-mail plausible (les espaces autour sont ignorés). */
export const isValidEmail = (email) => EMAIL.test(String(email || "").trim());

/** Clés d'erreur (textes de traduction) par champ, ou null. */
export function passwordErrors({ password, confirmation }) {
  const value = String(password || "");
  return {
    password: !value ? "Enter a password." : value.length < PASSWORD_MIN ? "At least 6 characters." : null,
    confirmation:
      !String(confirmation || "") ? "Confirm your password." : confirmation !== value ? "The passwords do not match." : null,
  };
}

export const hasPasswordErrors = (errors) => Boolean(errors.password || errors.confirmation);

/**
 * Message lisible d'un refus du serveur. Devise renvoie
 * `errors.full_messages` (tableau ou objet), `errors` (tableau) ou `message`.
 */
export function serverError(error) {
  const data = error?.response?.data;
  if (!data) return null;
  const full = data?.errors?.full_messages;
  if (Array.isArray(full) && full.length) return full.join(" ");
  if (full && typeof full === "object") return Object.values(full).flat().join(" ");
  if (Array.isArray(data?.errors) && data.errors.length) return data.errors.join(" ");
  if (typeof data?.message === "string") return data.message;
  if (typeof data?.error === "string") return data.error;
  return null;
}

/** Lien du mail de réinitialisation : la page du site en cours, pas une URL figée. */
export const resetPasswordUrl = () => `${window.location.origin}/reset-password`;
